// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filter-label {
  font-family: "Poppins" !important;
  font-weight: 500 !important;
  font-size: 0.9vw !important;
  color: #101010 !important;
}
 
.placeholder-label {
  font-family: "Karla" !important;
  font-weight: 500 !important;
  font-size: 0.9vw !important;
  /* line-height: 1.1vw !important; */
  letter-spacing: -0.41px !important;
  color: #595959 !important;
}
 
.modal-chip {
  background-color: #d9d9d9 !important;
  font-family: "Karla" !important;
  font-weight: 700 !important;
  font-size: 0.7vw !important;
  line-height: 100% !important;
  color: #191818 !important;
  padding: 1vw 0.6vw !important;
  height: 0.5vw;
  border-radius: 0.25vw !important;
  transition: all 0.4s ease !important;
  &:hover {
    background-color: #d3c7c7 !important;
  }
}
 
.search-modal-title {
  font-family: "Poppins" !important;
  font-weight: 600 !important;
  font-size: 0.85vw !important;
  letter-spacing: 0.00938em !important;
  color: #595959 !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/ui/FilterModal/CartPageModal/CartPageModal.css"],"names":[],"mappings":"AAAA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,2BAA2B;EAC3B,mCAAmC;EACnC,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,+BAA+B;EAC/B,2BAA2B;EAC3B,2BAA2B;EAC3B,4BAA4B;EAC5B,yBAAyB;EACzB,6BAA6B;EAC7B,aAAa;EACb,gCAAgC;EAChC,oCAAoC;EACpC;IACE,oCAAoC;EACtC;AACF;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,4BAA4B;EAC5B,oCAAoC;EACpC,yBAAyB;AAC3B","sourcesContent":[".filter-label {\n  font-family: \"Poppins\" !important;\n  font-weight: 500 !important;\n  font-size: 0.9vw !important;\n  color: #101010 !important;\n}\n \n.placeholder-label {\n  font-family: \"Karla\" !important;\n  font-weight: 500 !important;\n  font-size: 0.9vw !important;\n  /* line-height: 1.1vw !important; */\n  letter-spacing: -0.41px !important;\n  color: #595959 !important;\n}\n \n.modal-chip {\n  background-color: #d9d9d9 !important;\n  font-family: \"Karla\" !important;\n  font-weight: 700 !important;\n  font-size: 0.7vw !important;\n  line-height: 100% !important;\n  color: #191818 !important;\n  padding: 1vw 0.6vw !important;\n  height: 0.5vw;\n  border-radius: 0.25vw !important;\n  transition: all 0.4s ease !important;\n  &:hover {\n    background-color: #d3c7c7 !important;\n  }\n}\n \n.search-modal-title {\n  font-family: \"Poppins\" !important;\n  font-weight: 600 !important;\n  font-size: 0.85vw !important;\n  letter-spacing: 0.00938em !important;\n  color: #595959 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
